<script setup></script>

<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
    <g clip-path="url(#clip0_6144_42690)">
      <path
        d="M2.5 0.000488281H17.5C18.9167 0.000488281 20 1.08382 20 2.50049V17.5005C20 18.9172 18.9167 20.0005 17.5 20.0005H2.5C1.08333 20.0005 0 18.9172 0 17.5005V2.50049C0 1.08382 1.08333 0.000488281 2.5 0.000488281Z"
        fill="currentColor"
      />
      <rect x="5" y="9.00049" width="10" height="3" rx="1.5" fill="white" />
    </g>
    <defs>
      <clipPath id="clip0_6144_42690">
        <rect width="20" height="20" fill="white" transform="translate(0 0.000488281)" />
      </clipPath>
    </defs>
  </svg>
</template>
